import { render } from "./LargeAssetItem.vue?vue&type=template&id=1ab59342&scoped=true"
import script from "./LargeAssetItem.ts?vue&type=script&lang=js"
export * from "./LargeAssetItem.ts?vue&type=script&lang=js"

import "./LargeAssetItem.vue?vue&type=style&index=0&id=1ab59342&scoped=true&lang=css"

import exportComponent from "/Users/r.hutter/Resilio Sync/_Workspace/git/TitleTool-NG/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab59342"]])

export default __exports__